import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { AUDIO_LANGUAGE_MENU } from 'aria-viewer/contextmenu/contextMenuActions'
import { playAudio, stopAudio, optIn, AUDIO_TOUR } from 'aria-viewer/audiomanager/audioManagerActions'
import ContextMenu from './ContextMenu'
import { getTourGuideAudio } from 'aria-viewer/utils/functions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { changeLanguage } from 'aria-viewer/language/languageActions'

class AudioLanguageContextMenu extends PureComponent {
    constructor(props) {
        super(props)

        this.style = styleguide.contextMenu.dark

        this.state = {
            style: this.style,
        }
    }

    componentDidMount() {
        const heightPerRow = 70
        const availableHeight = this.refs.menu.getWrappedInstance().props.contextMenu.get('y')
        const maxRows = Math.floor(availableHeight / heightPerRow) - 1
        const maxHeight = heightPerRow * maxRows

        const style = { ...this.style, scroller: { maxHeight } }

        this.setState({ style })
    }

    render() {
        const {
            languagesAudio,
            navigation,
            point,
            selectedAudioLanguage,
            changeLanguage,
            stopAudio,
            playAudio,
            optIn,
        } = this.props

        return (
            <ContextMenu
                ref="menu"
                name={AUDIO_LANGUAGE_MENU}
                theme={this.state.style}
                options={{
                    list: languagesAudio.map(value => value.toObject()),
                    title: 'Audio Guide',
                    selected: selectedAudioLanguage.toObject(),
                    defaultAction: item => {
                        if (item.value == 'off') {
                            stopAudio(AUDIO_TOUR)
                            return
                        }

                        changeLanguage(item)

                        const src = getTourGuideAudio(point, item.language, navigation.get('orientation'))

                        if (src) {
                            playAudio(AUDIO_TOUR)
                            optIn()
                        }
                    },
                }}
            />
        )
    }
}

export default connect(
    mapSelectorsToProps(['languagesAudio', 'point', 'navigation', 'selectedAudioLanguage']),
    {
        changeLanguage,
        playAudio,
        stopAudio,
        optIn,
    }
)(AudioLanguageContextMenu)
